<ng-template #modalRegistrationEmail let-c="close" let-d="dismiss">
  <wsb-modal
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="modalRegistrationEmailForm()"
    [primaryDisabled]="addEmailRegistration.invalid || !areEmailsEquals"
    title="{{ 'user_auth0_email_request_title' | translate }}"
    [dismissButtonEnable]="false"
  >
    <div body>
      <p translate>user_auth0_email_request_descirption</p>
      <label translate>common_new_registration_email</label>
      <input type="text" class="form-control" [formControl]="addEmailRegistration" wsbAppControlValidator [fc]="addEmailRegistration" />
      <wsb-validation-error-msg [fc]="addEmailRegistration"></wsb-validation-error-msg>
      <label translate>common_confirm_email</label>
      <input type="text" class="form-control" [formControl]="repeatEmailRegistration" wsbAppControlValidator [fc]="addEmailRegistration"/>
      <wsb-validation-error-msg [fc]="repeatEmailRegistration"></wsb-validation-error-msg>
    </div>
  </wsb-modal>
</ng-template>
<ng-template #modalExpirePWD let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="btnModalExpirePWD()"
    primaryButtonText="login_passreset_submit"
    [dismissButtonEnable]="false"
    title="{{ 'login_passreset_expired_title' | translate }}"
  >
    <div body>
      <h5 class="accoutExpiredPwd">{{ user?.profile?.userName }}</h5>
      <p>{{ 'login_passreset_expired_intro' | translate }}</p>
      <!-- <input type="text" id="exipre_pwd"  [formControl]="accoutExpiredPwd" name="accountExpired"  readonly = true class="form-control  form-control--short" style="opacity: 1.35" /> -->
    </div>
    <div class="login-content login-toastr-container">
      <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
    </div>
  </wsb-modal>
</ng-template>
<div [ngClass]="{ 'has--centered-layout': isFullScreen, 'hide-navbar': isFullScreen }" class="layout" id="topbar-layout">
  <wsb-ui-app-header [hidden]="isFullScreen"></wsb-ui-app-header>
  <main class="layout__main" [ngClass]="{
    'has--sidebar-full': isSidebarFull,
    'has--sidebar-collapsed': !isSidebarFull
  }">
    <div class="layout__content w-100" id="main-container" [ngClass]="{'hide-navbar': isFullScreen}">
      <router-outlet></router-outlet>
    </div>
    <button class="nav-sidebar-trigger" (click)="toggleSidebar()" *ngIf="!isFullScreen">
      <span class="nav-sidebar-trigger__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
      <span class="nav-sidebar-trigger__bg" [inlineSVG]="'assets/images/icons/icon-sidemenu-trigger.svg'"></span>
    </button>
    <nav class="layout__nav-sidebar" [hidden]="isFullScreen" id="sidebar" >
      <div class="nav-sidebar">
        <div class="nav-sidebar__header-container">
          <div class="nav-sidebar__header">
            <button class="navbar-toggler" type="button" aria-label="Toggle navigation" (click)="closeMobileNav()">
              <span class="navbar-toggler__icon" [inlineSVG]="'assets/images/icons/icon-close.svg'"></span>
              <span class="navbar-toggler__text">Menu</span>
            </button>

            <a class="navbar-brand" href="#">
              <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l" [attr.src]="domain?.logoUrl" alt="Brand Logo" />
            </a>
          </div>

          <div class="nav-sidebar__header-secondary">
            <span class="navbar-company  fs-12">{{ userLogin }}</span>
          </div>
        </div>
        <ul class="nav-sidebar__menu" #navSidebarMenu>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['sms']"
              [ngClass]="{'is--active': !!childLinkSMS1?.isActive || !!childLinkSMS2?.isActive || !!childLinkSMS3?.isActive || !!childLinkSMS4?.isActive || !!childLinkSMS5?.isActive }">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-SMS"
              class="nav-item__submenu-state"
              checked="checked" />

            <label class="nav-item__label" for="state-submenu-SMS">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-msg-sms.svg'"
                placement="right"
                ngbTooltip="SMS"></span>
              <span class="nav-item__text" translate>menu_sms</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSMS1="routerLinkActive" routerLinkActive="is--active"><a [routerLink]="sendSmsPage" class="nav-item__label" translate>menu_sms_send</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSMS2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/sms/campaigns" class="nav-item__label" translate>menu_sms_list</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSMS3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/sms/templates" class="nav-item__label" translate>menu_sms_templates</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSMS4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/stats/sms" class="nav-item__label" translate>menu_sms_stats</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSMS5="routerLinkActive" routerLinkActive="is--active" ><a routerLink="/sms/senders" class="nav-item__label" translate>menu_sms_senders</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['sr']"
              [ngClass]="{'is--active': !!childLinkSR1?.isActive || !!childLinkSR2?.isActive || !!childLinkSR3?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-smsin"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-smsin">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-msg-inbound.svg'"
                placement="right"
                ngbTooltip="SMSIN"></span>
              <span class="nav-item__text" translate>menu_smsin</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSR1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/sms/in" class="nav-item__label" translate>menu_sms_in_inbound</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSR2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/smsin/settings" class="nav-item__label" translate>menu_sms_in_settings</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSR3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/smsin/stats" class="nav-item__label" translate>menu_sms_in_stats</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['smsadv']"
              [ngClass]="{'is--active': !!childLinkSMSADV1?.isActive || !!childLinkSMSADV2?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-smsadv"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-smsadv">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-smsadv.svg'"
                placement="right"
                ngbTooltip="SMS Adv"></span>
              <span class="nav-item__text" translate>menu_smsadv</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSMSADV1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/smsadv/create" class="nav-item__label" translate>menu_smsadv_create</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSMSADV2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/smsadv/campaigns" class="nav-item__label" translate>smsadv_campaigns_title</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['smsadvfr']"
              [ngClass]="{'is--active': !!childLinkSMSADVFR1?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-smsadvfr"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-smsadvfr">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-smsadv.svg'"
                placement="right"
                ngbTooltip="SMS Adv"></span>
              <span class="nav-item__text" translate>menu_smsadv</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSMSADVFR1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/bdd" class="nav-item__label" translate>menu_smsadv_create</a></li>
            </ul>
          </li>

          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['email']"
              [ngClass]="{'is--active': !!childLinkEMAIL1?.isActive || !!childLinkEMAIL2?.isActive || !!childLinkEMAIL3?.isActive || !!childLinkEMAIL4?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-email"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-email">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-email.svg'"
                placement="right"
                ngbTooltip="Email"></span>
              <span class="nav-item__text" translate>menu_mail</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkEMAIL1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/mail/send" class="nav-item__label" translate>menu_mail_send</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkEMAIL2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/mail/list" class="nav-item__label" translate>menu_mail_list</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkEMAIL3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/mail/templates" class="nav-item__label" translate>menu_mail_templates</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkEMAIL4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/mail/campaigns" class="nav-item__label" translate>menu_mail_settings</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['pages']"
              [ngClass]="{'is--active': !!childLinkLANDING1?.isActive || !!childLinkLANDING2?.isActive || !!childLinkLANDING3?.isActive || !!childLinkLANDING4?.isActive || !!childLinkLANDING5?.isActive }">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-landingpage"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-landingpage">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-landingpage.svg'"
                placement="right"
                ngbTooltip="Landing page"></span>
              <span class="nav-item__text" translate>menu_pages</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkLANDING1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/pages/create" class="nav-item__label" translate>menu_pages_create</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkLANDING2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/pages/list" class="nav-item__label" translate>menu_pages_list</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkLANDING3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/pages/templates" class="nav-item__label" translate>menu_pages_templates</a></li>
<!--              <li class="nav-item nav-sidebar__subitem" routerLinkActive="is&#45;&#45;active"><a routerLink="/stats/pages" class="nav-item__label" translate>menu_pages_stats</a></li>-->
              <li class="nav-item nav-sidebar__subitem" #childLinkLANDING4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/pages/list_domains" class="nav-item__label" translate>menu_pages_list_domains</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkLANDING5="routerLinkActive" routerLinkActive="is--active"><a routerLink="/stats/pages" class="nav-item__label" translate>menu_pages_stats</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['contacts']"
              [ngClass]="{'is--active': !!childLinkCONTACTS1?.isActive || !!childLinkCONTACTS2?.isActive || !!childLinkCONTACTS3?.isActive || !!childLinkCONTACTS4?.isActive || !!childLinkCONTACTS5?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-contacts"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-contacts">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-contacts.svg'"
                placement="right"
                ngbTooltip="Contacts"></span>
              <span class="nav-item__text" translate>menu_contacts</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkCONTACTS1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/contacts/list" class="nav-item__label" translate>menu_contacts_list</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkCONTACTS2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/contacts/groups" class="nav-item__label" translate>menu_contacts_groups</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkCONTACTS3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/contacts/import" class="nav-item__label" translate>menu_contacts_import</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkCONTACTS4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/contacts/dynamic_fields" class="nav-item__label" translate>menu_contacts_dynamic_fields</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkCONTACTS5="routerLinkActive" routerLinkActive="is--active"><a routerLink="/contacts/blocklist" class="nav-item__label" translate>menu_contacts_blacklist</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item" (click)="openRcp()" *ngIf="menuEntries['rcp']">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-rcp"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-rcp">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-rcp.svg'"
                placement="right"
                ngbTooltip="Rcp"></span>
              <span class="nav-item__text" translate>menu_rcp</span>
              <span class="badge badge-pill btn-primary ml-2" *ngIf="displayNewStudioBadge()" translate>common_new</span>
            </label>
          </li>
          <!-- External shop -->
          <li *ngIf="domain && menuEntries['external_shop']" class="nav-item nav-sidebar__item">
            <!--old <li *ngIf="domain && domain.shopUrl" class="nav-item nav-sidebar__item"> -->
            <label class="nav-item__label" for="state-submenu-shop">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-shop.svg'"
                placement="right"
                ngbTooltip="Shop"></span>
              <a target="_blank" [href]="domain.shopUrl +'?id='+ userIdKey" style="color:inherit" class="nav-item__text" translate>menu_shop</a>
            </label>
          </li>
           <!-- Internal shop -->
           <!-- old <li class="nav-item  nav-sidebar__item has--submenu" *ngIf="domain && !domain.shopUrl && menuEntries['shop'] && allowProfileManageAndShopAndBilling"
              [ngClass]="{'is--active': !!childLinkSHOP1?.isActive || !!childLinkSHOP2?.isActive}"> -->
          <li class="nav-item  nav-sidebar__item has--submenu" *ngIf="domain && menuEntries['internal_shop'] && allowProfileManageAndShopAndBilling"
              [ngClass]="{'is--active': !!childLinkSHOP1?.isActive || !!childLinkSHOP2?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-shop"
              class="nav-item__submenu-state" />
            <label class="nav-item__label" for="state-submenu-shop">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-shop.svg'"
                placement="right"
                ngbTooltip="Shop"></span>
              <span class="nav-item__text" translate>menu_shop</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSHOP1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/shop/index" class="nav-item__label" translate>menu_shop_index</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSHOP2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/shop/cart" class="nav-item__label" translate>menu_shop_cart</a></li>
              <!-- <li class="nav-item nav-sidebar__subitem" #childLinkSHOP2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/shop/cart2" class="nav-item__label" translate>menu_shop_cart</a></li>               -->
              <!-- <li class="nav-item nav-sidebar__subitem" #childLinkSHOP2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/shop/cart-summary2" class="nav-item__label" translate>menu_shop_cart</a></li> -->
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['subaccount']"
              [ngClass]="{'is--active': !!childLinkSUBACCOUNT1?.isActive || !!childLinkSUBACCOUNT2?.isActive || !!childLinkSUBACCOUNT3?.isActive || !!childLinkSUBACCOUNT4?.isActive || !!childLinkSUBACCOUNT5?.isActive || !!childLinkSUBACCOUNT6?.isActive || !!childLinkSUBACCOUNT7?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-reseller"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-reseller">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-subaccounts.svg'"
                placement="right"
                ngbTooltip="Reseller"></span>
              <span class="nav-item__text" translate>menu_reseller</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/reseller/subaccounts" class="nav-item__label" translate>menu_reseller_subaccounts</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/reseller/profiles" class="nav-item__label" translate>menu_reseller_profiles</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT3="routerLinkActive" routerLinkActive="is--active" *ngIf="menuEntries['subaccount_prices']"><a routerLink="/reseller/prices" class="nav-item__label" translate>menu_reseller_prices</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/reseller/stats" class="nav-item__label" translate>menu_reseller_stats</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT5="routerLinkActive" routerLinkActive="is--active"><a routerLink="/reseller/history" class="nav-item__label" translate>menu_reseller_history</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT6="routerLinkActive" routerLinkActive="is--active" *ngIf="menuEntries['sms_senders']"><a routerLink="/reseller/senders" class="nav-item__label" translate>menu_reseller_senders</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkSUBACCOUNT7="routerLinkActive" routerLinkActive="is--active"><a routerLink="/reseller/settings" class="nav-item__label" translate>menu_reseller_settings</a></li>
            </ul>
          </li>
          <li class="nav-item  nav-sidebar__item  has--submenu" *ngIf="menuEntries['partner']"
              [ngClass]="{'is--active': !!childLinkPARTNER1?.isActive || !!childLinkPARTNER2?.isActive || !!childLinkPARTNER3?.isActive || !!childLinkPARTNER4?.isActive}">
            <input
              type="checkbox"
              name="state-submenu"
              id="state-submenu-partner"
              class="nav-item__submenu-state" />

            <label class="nav-item__label" for="state-submenu-partner">
              <span
                class="nav-item__icon"
                [inlineSVG]="'assets/images/icons/menu/icon-partners.svg'"
                placement="right"
                ngbTooltip="Partner"></span>
              <span class="nav-item__text" translate>menu_partner</span>
              <span class="nav-item__arrow" [inlineSVG]="'assets/images/icons/icon-arrow.svg'"></span>
            </label>

            <ul class="nav-item__submenu  nav-sidebar__submenu">
              <li class="nav-item nav-sidebar__subitem" #childLinkPARTNER1="routerLinkActive" routerLinkActive="is--active"><a routerLink="/partner/dashboard" class="nav-item__label" translate>menu_partner_dashboard</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkPARTNER2="routerLinkActive" routerLinkActive="is--active"><a routerLink="/partner/setup" class="nav-item__label" translate>menu_partner_setup</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkPARTNER3="routerLinkActive" routerLinkActive="is--active"><a routerLink="/partner/analytics" class="nav-item__label" translate>menu_partner_analytics</a></li>
              <li class="nav-item nav-sidebar__subitem" #childLinkPARTNER4="routerLinkActive" routerLinkActive="is--active"><a routerLink="/partner/payout" class="nav-item__label" translate>menu_partner_payout</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </main>
</div>
